import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {Store} from '@ngxs/store';
import {Observable, throwError} from 'rxjs';
import {UserProfile} from '@shared/interfaces';
import {FirebaseApp} from '@angular/fire/app';
import {
  Auth,
  authState,
  fetchSignInMethodsForEmail,
  getAuth,
  signInWithPopup
} from '@angular/fire/auth';

import {
  GoogleAuthProvider
} from '@firebase/auth';

import {Firestore, doc, docSnapshots, updateDoc} from '@angular/fire/firestore';
import {DocumentData, DocumentSnapshot} from 'rxfire/firestore/interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  headers: HttpHeaders;
  apiUrl: string;
  userId: string;
  userInfoPath: string;
  auth: Auth;

  constructor(private http: HttpClient, private store: Store, private afApp: FirebaseApp, private firestore: Firestore) {
    this.apiUrl = environment.apiUrl;
    this.userInfoPath = `superusers`;
    this.auth = getAuth(this.afApp);
  }

  getUserData(userId): Observable<DocumentSnapshot<DocumentData>> {
    if (!userId) {
      return throwError({message: 'You are not authenticated, please refresh the page!'});
    }

    const userDoc = doc(this.firestore, this.userInfoPath, userId);
    return docSnapshots(userDoc);
  }

  currentUser() {
    return this.auth.currentUser;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  getAuthState() {
    return authState(this.auth);
  }

  async signInWithGoogle() {
    const provider = this.googleProvider();
    provider.setCustomParameters({hd: 'carvry.com'});
    return signInWithPopup(this.auth, provider);
  }

  signOut() {
    return this.auth.signOut();
  }

  googleProvider() {
    return new GoogleAuthProvider();
  }

  async linkAcctToGoogle(linkType: string) {
    // Change the current user to the one I want to link to
    return this.signInWithGoogle();
  }

  createUserEntry(data: Partial<UserProfile>) {
    return this.http.post(this.getUrl('profile/create'), data)
      .toPromise();
  }

  fetchSignInMethods(email: string) {
    return fetchSignInMethodsForEmail(this.auth, email);
  }

  async editUserData(oldUserData, userData: UserProfile) {
    if (!userData) {
      return Promise.reject({message: 'No data exists!'});
    }
    let emailChanged = false;
    if (oldUserData && oldUserData.email !== userData.email) {
      emailChanged = true;
    }
    return this.http.post(this.getUrl('profile/edit'), {userData, emailChanged})
      .toPromise();
  }

  async editUserPreference(userId: string, key: string, value: boolean) {
    const userDoc = doc(this.firestore, this.userInfoPath, userId);
    return updateDoc(userDoc, {
      [key]: value
    });
  }
}
